/* eslint-disable import/no-anonymous-default-export */
import axios, {AxiosRequestConfig, AxiosRequestHeaders} from 'axios'
import handleError from './handleError'
// import {BASE_API_URL} from '@env';

const getInstance = (
  _baseRoot: any,
  _isToken = '',
  headers: AxiosRequestConfig<any> | undefined
) => {
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_BASE_API_URL}`,
    timeout: 30000,
    ...headers,
  })
  instance.interceptors.request.use(
    (config: any) => {
      if (config.method === 'get' || config.method === 'delete' || config.data === undefined) {
        config.data = true
      }
      config['headers']['Authorization'] = 'Bearer ' + localStorage.getItem('apiToken')
      const newConfig = config
      return newConfig
    },
    (error) => Promise.reject(error)
  )
  return instance
}

const httpRequest = (
  method: string,
  path: any,
  data: any,
  headers = {},
  baseRoot: string,
  token: string | undefined
) => {
  return new Promise((resolve, reject) => {
    switch (method) {
      case 'delete':
        getInstance(baseRoot, token, headers)
          [method](path, data)
          .then((response: {data: unknown}) => resolve(response.data))
          .catch((error: any) => reject(handleError(error)))
        break
      case 'post':
        getInstance(baseRoot, token, headers)
          [method](path, data)
          .then((response: {data: unknown}) => resolve(response.data))
          .catch((error: any) => reject(handleError(error)))
        break
      case 'put':
        getInstance(baseRoot, token, headers)
          [method](path, data)
          .then((response: {data: unknown}) => resolve(response.data))
          .catch((error: any) => reject(handleError(error)))
        break
      case 'patch':
        getInstance(baseRoot, token, headers)
          [method](path, data)
          .then((response: {data: unknown}) => resolve(response.data))
          .catch((error: any) => reject(handleError(error)))
        break
      default:
        getInstance(baseRoot, token, headers)
          ['get'](path, data)
          .then((response: {data: unknown}) => resolve(response.data))
          .catch((error: any) => reject(handleError(error)))
        break
    }
  })
}

export default {
  get(path: any, data?: any, headers?: {} | undefined) {
    return httpRequest('get', path, data, headers, '', '')
  },
  post(path: any, data?: any, headers?: {} | undefined) {
    return httpRequest('post', path, data, headers, '', '')
  },
  put(path: any, data?: any, headers?: {} | undefined) {
    return httpRequest('put', path, data, headers, '', '')
  },
  delete(path: any, data?: any, headers?: {} | undefined) {
    return httpRequest('delete', path, data, headers, '', '')
  },
  patch(path: any, data?: any, headers?: {} | undefined) {
    return httpRequest('patch', path, data, headers, '', '')
  },
}
